<template>
  <section
    id="setplan"
    class="pb-7"
  >
    <div class="co-container-lg px-4 pt-5 text-center">
      <h2 class="co-display-9 mb-3 text-center font-bold">
        複数コース受講でさらにお得
      </h2>
      <h3 class="co-display-11 mb-5  text-center">
        最大
        <span class="font-bold text-co-danger-500">55,000</span>
        円もお得
      </h3>

      <div class="mb-8 flex justify-center gap-4">
        <!-- Python+AIセット -->
        <a
          class="te-bg-python-ai-set-image-s flex h-full basis-6/12 flex-col items-center justify-center gap-2 rounded bg-cover p-4 text-white hover:text-white hover:brightness-75 md:basis-4/12 md:gap-3"
          href="/set/python-ai"
        >
          <img
            src="~/assets/images/Te/TeCourse/Index/Tag/icon-reskill.svg"
            alt="受講料最大70％支給"
            width="156"
          >
          <img
            src="~/assets/images/Te/TeCourse/Index/Set/python-ai-set.svg"
            alt="Python+AIセット"
            width="76"
            height="40"
          >
          <h3
            class="co-display-12 mb-0 font-bold leading-normal"
          >
            Python
            <br>
            AI
            <br>
            セット
          </h3>
        </a>
        <!-- Python+データサイエンスセット -->
        <a
          class="te-bg-python-datascience-set-image-s flex h-full basis-6/12 flex-col items-center justify-center gap-2 rounded bg-cover p-4 text-white hover:text-white hover:brightness-75 md:basis-4/12 md:gap-3"
          href="/set/python-datascience"
        >
          <img
            src="~/assets/images/Te/TeCourse/Index/Tag/icon-reskill.svg"
            alt="受講料最大70％支給"
            width="156"
          >
          <img
            src="~/assets/images/Te/TeCourse/Index/Set/python-datascience-set.svg"
            alt="Python+データサイエンスセット"
            width="76"
            height="40"
          >
          <h3
            class="co-display-12 mb-0 font-bold leading-normal"
          >
            Python
            <br>
            データサイエンス
            <br>
            セット
          </h3>
        </a>
      </div>
    </div>
  </section>
</template>

<style scoped>
/* 背景画像 */
.te-bg-python-ai-set-image-s {
  background-image: url('~/assets/images/Te/TeCourse/Index/Set/python-ai-set-s.jpg');
}

.te-bg-python-datascience-set-image-s {
  background-image: url('~/assets/images/Te/TeCourse/Index/Set/python-datascience-set-s.jpg');
}
</style>
